export const translations = {
  en: {
    appTitle: 'TimeTracker Pro',
    appSubtitle: 'Project Time Management',
    dashboard: 'Dashboard',
    timeTracking: 'Time Tracking',
    projects: 'Projects',
    customers: 'Customers',
    employees: 'Employees',
    reporting: 'Reporting',
    myReports: 'My Reports',
    admin: 'Admin',
    projectManager: 'Project Manager',
    employee: 'Employee',
    hoursToday: 'Hours Today',
    hoursTotal: 'Hours Total',
    billable: 'Billable',
    nonBillable: 'Non-Billable',
    signIn: 'Sign In with Microsoft',
    signOut: 'Sign Out',
    loading: 'Loading...',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    newEntry: 'New Entry',
    selectProject: 'Select project...',
    selectActivity: 'Select activity...',
    date: 'Date',
    hours: 'Hours',
    activity: 'Activity',
    description: 'Description',
    billableCheckbox: 'Billable (can be invoiced to customer)',
    entrySaved: '✅ Time entry successfully saved!',
    errorOccurred: '⚠️ An error occurred. Please try again.',
    editEntry: 'Edit Entry',
    deleteEntry: 'Delete Entry',
    confirmDelete: 'Are you sure you want to delete this time entry?',
    entryUpdated: '✅ Time entry successfully updated!',
    entryDeleted: '✅ Time entry successfully deleted!',
    update: 'Update',
    allClients: 'All Clients',
  },
  de: {
    appTitle: 'TimeTracker Pro',
    appSubtitle: 'Projektzeit-Management',
    dashboard: 'Dashboard',
    timeTracking: 'Zeiterfassung',
    projects: 'Projekte',
    customers: 'Kunden',
    employees: 'Mitarbeiter',
    reporting: 'Reporting',
    myReports: 'Meine Reports',
    admin: 'Admin',
    projectManager: 'Projektmanager',
    employee: 'Mitarbeiter',
    hoursToday: 'Stunden Heute',
    hoursTotal: 'Stunden Gesamt',
    billable: 'Verrechenbar',
    nonBillable: 'Nicht verrechenbar',
    signIn: 'Mit Microsoft anmelden',
    signOut: 'Abmelden',
    loading: 'Lädt...',
    save: 'Speichern',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    newEntry: 'Neuer Eintrag',
    selectProject: 'Projekt wählen...',
    selectActivity: 'Aktivität wählen...',
    date: 'Datum',
    hours: 'Stunden',
    activity: 'Aktivität',
    description: 'Beschreibung',
    billableCheckbox: 'Verrechenbar (kann dem Kunden in Rechnung gestellt werden)',
    entrySaved: '✅ Zeiteintrag erfolgreich gespeichert!',
    errorOccurred: '⚠️ Ein Fehler ist aufgetreten. Bitte erneut versuchen.',
    editEntry: 'Eintrag bearbeiten',
    deleteEntry: 'Eintrag löschen',
    confirmDelete: 'Möchten Sie diesen Zeiteintrag wirklich löschen?',
    entryUpdated: '✅ Zeiteintrag erfolgreich aktualisiert!',
    entryDeleted: '✅ Zeiteintrag erfolgreich gelöscht!',
    update: 'Aktualisieren',
    allClients: 'Alle Kunden',
  },
  fr: {
    appTitle: 'TimeTracker Pro',
    appSubtitle: 'Gestion du temps de projet',
    dashboard: 'Tableau de bord',
    timeTracking: 'Saisie du temps',
    projects: 'Projets',
    customers: 'Clients',
    employees: 'Employés',
    reporting: 'Reporting',
    myReports: 'Mes rapports',
    admin: 'Admin',
    projectManager: 'Chef de projet',
    employee: 'Employé',
    hoursToday: "Heures aujourd'hui",
    hoursTotal: 'Heures totales',
    billable: 'Facturable',
    nonBillable: 'Non facturable',
    signIn: 'Se connecter avec Microsoft',
    signOut: 'Se déconnecter',
    loading: 'Chargement...',
    save: 'Enregistrer',
    cancel: 'Annuler',
    delete: 'Supprimer',
    edit: 'Modifier',
    newEntry: 'Nouvelle saisie',
    selectProject: 'Sélectionner un projet...',
    selectActivity: 'Sélectionner une activité...',
    date: 'Date',
    hours: 'Heures',
    activity: 'Activité',
    description: 'Description',
    billableCheckbox: 'Facturable (peut être facturé au client)',
    entrySaved: '✅ Saisie enregistrée avec succès!',
    errorOccurred: '⚠️ Une erreur est survenue. Veuillez réessayer.',
    editEntry: 'Modifier la saisie',
    deleteEntry: 'Supprimer la saisie',
    confirmDelete: 'Voulez-vous vraiment supprimer cette saisie?',
    entryUpdated: '✅ Saisie mise à jour avec succès!',
    entryDeleted: '✅ Saisie supprimée avec succès!',
    update: 'Mettre à jour',
    allClients: 'Tous les clients',
  }
};